export default {
    rowSelection: false,
    toolbar: false,
    fieldControl: false,
    pagination: false,
    title: '银行信息',
    columns: [
      {
        title: '银行名称',
        dataIndex: 'bankName',
        width: 100,
      },
      {
        title: '分行名称',
        dataIndex: 'bankBranchName',
        width: 180,
      },
      {
        title: '开户名',
        dataIndex: 'openAccountName',
        width: 110,
      },
      {
        title: '身份证',
        dataIndex: 'idCard',
        width: 140,
        render: 'idCardApproval',
      },
      {
        title: '卡号',
        dataIndex: 'accountCode',
        width: 140,
        render: 'accountCodeApproval',
      },
      {
        title: '银行卡正面',
        dataIndex: 'imgFrontUrl',
        width: 150,
        render: 'imgFrontUrlApproval',
      },
      {
        title: '银行卡背面',
        dataIndex: 'imgBackUrl',
        width: 150,
        render: 'imgBackUrlApproval',
      },
      {
        title: '类型',
        dataIndex: 'mainFlag',
        render: 'bankTypeApproval',
        width: 100,
      },
      {
        title: '操作',
        dataIndex: 'actionTool',
        width: 140,
        render: 'actionTool',
        fixed: 'right',
      },
    ],
    search: [],
    footer: [],
  };
